import { render, staticRenderFns } from "./ArticleapplisDetail.vue?vue&type=template&id=0bcda8fa&scoped=true&"
import script from "./ArticleapplisDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleapplisDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleapplisDetail.vue?vue&type=style&index=0&id=0bcda8fa&lang=scss&scoped=true&"
import style1 from "./ArticleapplisDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcda8fa",
  null
  
)

export default component.exports